"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagLarge = exports.TagMedium = exports.TagSmall = exports.TagXSmall = exports.FieldLarge = exports.FieldMedium = exports.FieldSmall = exports.DatePickerDateCellLarge = exports.DatePickerDateCellMedium = exports.DatePickerDateCellSmall = exports.ControlSwitchSmall = exports.ControlSwitchLarge = exports.ControlRadioSmall = exports.ControlRadioLarge = exports.ControlCheckboxSmall = exports.ControlCheckboxLarge = exports.ButtonLarge = exports.ButtonMedium = exports.ButtonSmall = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonSmall = 32;
exports.ButtonSmall = ButtonSmall;
var ButtonMedium = 40;
exports.ButtonMedium = ButtonMedium;
var ButtonLarge = 48;
exports.ButtonLarge = ButtonLarge;
var ControlCheckboxLarge = 18;
exports.ControlCheckboxLarge = ControlCheckboxLarge;
var ControlCheckboxSmall = 16;
exports.ControlCheckboxSmall = ControlCheckboxSmall;
var ControlRadioLarge = 18;
exports.ControlRadioLarge = ControlRadioLarge;
var ControlRadioSmall = 16;
exports.ControlRadioSmall = ControlRadioSmall;
var ControlSwitchLarge = 24;
exports.ControlSwitchLarge = ControlSwitchLarge;
var ControlSwitchSmall = 20;
exports.ControlSwitchSmall = ControlSwitchSmall;
var DatePickerDateCellSmall = 32;
exports.DatePickerDateCellSmall = DatePickerDateCellSmall;
var DatePickerDateCellMedium = 40;
exports.DatePickerDateCellMedium = DatePickerDateCellMedium;
var DatePickerDateCellLarge = 48;
exports.DatePickerDateCellLarge = DatePickerDateCellLarge;
var FieldSmall = 32;
exports.FieldSmall = FieldSmall;
var FieldMedium = 40;
exports.FieldMedium = FieldMedium;
var FieldLarge = 48;
exports.FieldLarge = FieldLarge;
var TagXSmall = 14;
exports.TagXSmall = TagXSmall;
var TagSmall = 20;
exports.TagSmall = TagSmall;
var TagMedium = 24;
exports.TagMedium = TagMedium;
var TagLarge = 32;
exports.TagLarge = TagLarge;